<template>
  <vx-card>
    <place-add @done="$router.go(-1)" />
  </vx-card>
</template>

<script>
import PlaceAdd from '@/views/components/forms/PlaceAdd'

export default {
  name: 'BusinessPlaceAdd',
  components: { PlaceAdd }
}
</script>

<style scoped></style>
